import { gql } from '@apollo/client';

export const GetOrganizationSecurityAccessRights = gql`
  query GetOrganizationSecurityAccessRights($code: String!) {
    organizationSecurityAccessRights(organizationCode: $code) {
      canEnforceTwoFactor
    }
  }
`;
